
export class VisitLookup {

    static GetVisit(id: number): string {
        switch (id) {
            case (1): return "Screening";
            case (2): return "Baseline";
            case (3): return "Mid-Intervention";
            case (4): return "End of Intervention";
            case (5): return "Day 45";
            case (6): return "Day 60";
            case (7): return "Day 90";
            case (8): return "Day 120";
            case (9): return "End of Follow-Up";      
            case (10): return "Start of Intervention";
            case (11): return "Week 1";
            case (12): return "Week 2";
            case (13): return "Week 3";
            case (14): return "Week 4";
            case (15): return "Week 5";
            case (16): return "Week 7";
            case (17): return "Week 9";
            case (18): return "Week 10";
            case (19): return "Week 11";
            case (20): return "Week 13";
            case (21): return "Week 14";
            case (22): return "Week 15";
            case (23): return "Week 17";
            case (24): return "Week 18";
            case (25): return "Week 19";
            case (26): return "Week 20";
            case (27): return "Week 21";
            case (28): return "Week 22";
            case (29): return "Week 23";
            case (30): return "Week 24";
            case (31): return "Week 25";
            case (32): return "Week 26";
            case (33): return "Week 27";
            case (34): return "Week 28";
            case (35): return "Week 29";
            case (36): return "Week 30";
            case (37): return "Week 31";
            case (38): return "Week 32";
            case (39): return "Week 33";
            case (40): return "Week 34";
            case (41): return "Week 35";
            case (42): return "Week 6";
            case (43): return "Week 8";
            case (44): return "Week 12";
            case (45): return "Week 16";

            default: return "Unknown";
        }
    }

    static GetVisitOrdering(id: number): number {
        switch (id) {
            case (1): return 1; //"Screening";
            case (2): return 2; //"Baseline";
            case (10): return 3; //"Start of Intervention";
            case (3): return 4; //"Mid-Intervention";
            case (11): return 5; //"Week 1";
            case (12): return 6; //"Week 2";
            case (13): return 7; //"Week 3";
            case (14): return 8; //"Month 1";
            case (15): return 9; //"Week 5";
            case (42): return 10; //"Week 6";
            case (16): return 11; //"Week 7";
            case (43): return 12; //"Month 2";
            case (17): return 13; //"Week 9";
            case (18): return 14; //"Week 10";
            case (19): return 15; //"Week 11";
            case (44): return 16; //"Month 3";
            case (20): return 17; //"Week 13";
            case (21): return 18; //"Week 14";
            case (22): return 19; //"Week 15";
            case (45): return 20; //"Month 4";
            case (23): return 21; //"Week 17";
            case (24): return 22; //"Week 18";
            case (25): return 23; //"Week 19";
            case (26): return 24; //"Month 5";
            case (27): return 25; //"Week 21";
            case (28): return 26; //"Week 22";
            case (29): return 27; //"Week 23";
            case (30): return 28; //"Month 6";
            case (31): return 29; //"Week 25";
            case (32): return 30; //"Week 26";
            case (33): return 31; //"Week 27";
            case (34): return 32; //"Month 7";
            case (35): return 33; //"Week 29";
            case (36): return 34; //"Week 30";
            case (37): return 35; //"Week 31";
            case (38): return 36; //"Month 8";
            case (39): return 37; //"Week 33";
            case (40): return 38; //"Week 34";
            case (41): return 39; //"Week 35";
            case (4): return 40; //"End of Intervention";
            case (5): return 41; //"Day 45";
            case (6): return 42; //"Day 60";
            case (7): return 43; //"Day 90";
            case (8): return 44; //"Day 120";
            case (9): return 45; //"End of Follow-Up";      
            default: return 100; // "Unknown";
        }
    }

    static GetRequired(id: number): string {
        switch (id) {
            case (1): return "Yes";
            case (2): return "No";
            default: return "Unknown";
        }
    }

    static GetVisitStatus(id: number): string {
        switch (id) {
            case (1): return "Completed";
            case (2): return "Not Yet Due";
            case (3): return "Overdue";
            case (4): return "Not Done";
            case (5): return "Discontinued Prior";
            case (6): return "Not Yet Due (≤30 Days)";
            case (7): return "Not Yet Due (+30 Days)";
            case (20): return "In Window";
            case (21): return "± 1 - 3 Days";
            case (22): return "± 4 - 7 Days";
            case (23): return "± 8 - 14 Days";
            case (24): return "15+ Days";
            default: return "Unknown";
        }
    }

    static GetVisitColorIndex(id: number): number {
        switch (id) {
            case (1): return 500; //Completed
            case (2): return 501; //Not Yet Due
            case (3): return 502; //Overdue
            case (4): return 503; //Not Done
            case (5): return 504; //Discontinued Prior
            case (6): return 501; //Not Yet Due <= 30 Days
            case (7): return 505; //Not Yet Due > 30 Days
            case (20): return 500; //In Window
            case (21): return 501; //1 to 3 Days Outside Window
            case (22): return 502; //4 to 7 Days Outside Window
            case (23): return 503; //8 to 14 Days Outside Window
            case (24): return 504; //15 or More Days Outside Widow
            default: return 0;
        }
    }

    //static GetVisitStatusArray(): string[] {
    //    return [ "Completed", "Overdue", "Not Done", "Discontinued Prior", "Not Yet Due" ];
    //}

    //static GetCompletionTimingArray(): string[] {
    //    return ["In Window", "1 to 3 Days Outside Window", "4 to 7 Days Outside Window", "8 to 14 Days Outside Window", "15 or More Days Outside Widow"];
    //}
}